<template>
    <div class="knowledge_base_type">
      <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <div class="demo-split" :style="typeHeight">
          <div  class="demo-split-pane" style="float:left;border-right:1px solid #eeeeee;width:30%">
            <div class="panel-header">
              <div class="panel-title" style="font-weight:bold">知识分类</div>
              <div class="panel-tool" title="知识分类编辑">
                <a style="width: 20px;height: 20px;" href="javascript:void(0)" @click="setKnowType">
                  <span class="el-icon-edit"></span>
                </a>
              </div>
            </div>
            <div class="ztree" id="knowTree"></div>
          </div>
          <div class="demo-split-pane" style="float:right;width:70%">
            <div class="fixed_table">
              <div class="fixed_search">
                <div class="fixed_search_input">
                  <Input v-model="tittle" placeholder="输入标题及内容" title="知识库标题及内容"/>
                </div>
                <div class="fixed_search_input">
                  <Select v-model="creator" placeholder="请选择作者" clearable>
                    <Option v-for="(option, index) in creators" :value="option.id" :key="index">{{option.employeeName}}</Option>
                  </Select>
                </div>
                <div class="date_selected fixed_search_input">
                  <el-date-picker v-model="starEndTime" unlink-panels type="datetimerange" start-placeholder="开始创建时间" end-placeholder="结束创建时间" align="left" :default-time="['00:00:00', '23:59:59']" :editable="editable" :picker-options="pickerOptions"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </div>
                <div class="fixed_operation_btn">
                  <Button type="primary" @click="initSearch">查询</Button>
                  <Button class="search_btn" type="success" style="margin-left: 10px;" @click="addKnlgContent" v-if="roleList['6_2-7']">添加</Button>
                </div>
              </div>
              <div class="table_head">
                <table>
                  <tr>
                    <th class="font_style_set" style="width:5%;">置顶</th>
                    <th class="font_style_set" style="width:15%;">标题</th>
                    <th class="font_style_set" style="width:15%;">创建人员</th>
                    <th class="font_style_set" style="width:10%;">创建时间</th>
                    <th class="font_style_set" style="width:10%;">更新时间</th>
                    <th class="font_style_set" style="width:15%;border-right: 0px">操作</th>
                  </tr>
                </table>
              </div>
              <div style="border-bottom: 1px solid rgb(235, 238, 245);" class="footer_style" :style="tableHeight">
                <table class="table_head_footer">
                  <tr v-for="(item , index) in infoTableList" :key="index" :id="item.id" :class="{back_color:(index+1)%2==0,'currentKnowId':currentKnowId==item.id}"  @click="getTrees(item.baseId,item.id)">
                    <td  style="width:5%;">{{item.isUp}}</td>
                    <td  style="width:15%;">{{item.tittle}}</td>
                    <td  style="width:15%;">{{item.creatorName}}</td>
                    <td  style="width:10%;">{{item.createTime}}</td>
                    <td  style="width:10%;">{{item.updateTime}}</td>
                    <td class="template_table_btn" style="width:15%;">
                      <span class="search_btn" :class="{'currentKnowId':currentKnowId==item.id}" @click="openKnowContent(item.id,item.tittle)" v-if="roleList['6_2-4']">查看</span>
                      <span class="search_btn" :class="{'currentKnowId':currentKnowId==item.id}" @click="editKnowContent(item.id)" v-if="roleList['6_2-5']">编辑</span>
                      <span class="search_btn" :class="{'currentKnowId':currentKnowId==item.id}" @click="deleteKnow(item.id)" v-if="roleList['6_2-6']">删除</span>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="page_style">
                  <Page :total="total" size="small"  :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
                <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
              </div>
            </div>
          </div>
      </div>
      <knowledgeContentPop :showDataKnlgEdit="showDataKnlgEdit" :baseIdList="baseIdList" :selectTreeIdForContent="selectTreeIdForContent" :contentId="contentId"  @closeDataKnlgPop="closeDataKnlgPop"></knowledgeContentPop>
      <knowledgeCategoryPop :showCategoryEdit="showCategoryEdit" :categoryId="categoryId" :selectPid="selectPid"  @closeCategoryKnlgPop="closeCategoryKnlgPop"></knowledgeCategoryPop>
    </div>
</template>

<script>
    import {publicFunClass} from '@/components/js/PublicFunClass.js'
    import knowledgeCategoryPop from '@/components/knowledgeBase/KnowledgeCategoryPop.vue'
    import knowledgeContentPop from '@/components/knowledgeBase/KnowledgeContentPop.vue'
    export default {
        name: "KnowledgeBaseType",
        mixins:[publicFunClass],
        components:{
          knowledgeCategoryPop,
          knowledgeContentPop
        },
        props:{
          pageCode:String
        },
        data(){
          return {
            showPageCount:0,
            selectTreeIdForContent:'',
            split1: 0.3,
            currentKnowId:'',
            inspectTreeData:[],
            isOpenList:[{'id':'1','name':'否'},{'id':'0','name':'是'}],
            creator:'',
            tittle:'',
            starEndTime:[],
            creators:[],
            typeHeight:{height:''},
            tableHeight:{height:''},
            singleCheckedList:[],
            infoTableList:[],
            spinShow: true,
            roleList:JSON.parse(localStorage.getItem("roleList")),
            pageSizeList:[10,20,30,40,50,100,200],
            speedChangePage: 1,
            currentPage:1,
            pageSize:20,
            total:0,
            checkedAll:false,
            selectedTreeId:'0',
            selectedTreeName:'',
            categoryId:'',
            selectPid:'',
            contentId:'',
            showCategoryEdit:false,
            showDataKnlgEdit:false,
            openDataKnlgPop:false,
            configInfo: JSON.parse(localStorage.getItem("configInfo")),
            baseIdList:[],
            editable:false
          }
        },
        methods:{
          closeDataKnlgPop:function(flag){
            this.showDataKnlgEdit=false;
            if(flag){
              this.initSearch();
            }
          },
          closeCategoryKnlgPop:function(flag){
            this.showCategoryEdit=false;
            if(flag){
              this.initSearchTree("knowTree");
              this.selectedTreeId="0";
              this.initSearch();
            }
          },
          //查看知识库内容
          openKnowContent:function(id,name){
            if(name && name.length>5){
              name = name.substring(0,5)+"…";
            }
            this.$emit("showStandardPage","6_3-"+id+","+name+"",id);
          },
          //添加知识库
          addKnlgContent:function () {
            this.contentId="";
            this.showDataKnlgEdit=true;
            this.selectTreeIdForContent=this.selectedTreeId;
            this.baseIdList=this.inspectTreeData;
          },
          //编辑知识库
          editKnowContent:function (id) {
            this.contentId=id+"";
            this.showDataKnlgEdit=true;
            this.baseIdList=this.inspectTreeData;
          },
          //打开操作类目页面
          setKnowType:function(){
            this.showCategoryEdit=true;
          },
          //删除知识库列表
          deleteKnow:function (id) {
            let that=this;
            let param={
              isDelete:"1",
              journalType:"知识库管理=>知识总览=>删除",
              menuId:"6_2-7",
              id:id,
              type:'1',
            };
            this.$Modal.confirm({
              title: '提示',
              content: "是否确定删除",
              onOk: () => {
                that.$http.post("knowledge/doDelete.json",param) .then(function (res) {
                  let result=res.data.flag;
                  if(result!="666"){
                    that.$alert(res.data.msg, '提示', {
                      confirmButtonText: '确定'
                    });
                    return false;
                  }
                  that.$Message.info("删除成功");
                  that.initSearch();
                });
              }
            });
          },
          initSearch:function () {
            this.spinShow=true;
            let TreeIdForSelect = this.selectedTreeId;
            if("0"==this.selectedTreeId){
              TreeIdForSelect="";
            }
            let param={
              type:'0',
              remark:'1',
              baseId:TreeIdForSelect,
              search:this.tittle,
              creator:this.creator,
              createTime:this.starEndTime.length==0?"":this.starEndTime.toString(),
              journalType:"null",
              menuId:"null",
              pageNum:this.currentPage,
              pageSize:this.pageSize,
            };
            this.speedChangePage=this.currentPage;
            let that=this;
            this.$http.post("knowledge/toIndex.json",param) .then(function (res) {
              let result=res.data.flag;
              that.spinShow=false;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              that.infoTableList=res.data.obj.list.content;
              that.total=res.data.obj.list.totalSize;
              that.creators=res.data.obj.creators;
            });
          },
          getTrees:function (baseId,id) {
            let zTree_Menu = $.fn.zTree.getZTreeObj("knowTree");
            let node = zTree_Menu.getNodeByParam("id", baseId);
            zTree_Menu.selectNode(node, true);//指定选中ID的节点
            zTree_Menu.expandNode(node, true, false);
            this.currentKnowId=id;
          }
        },
        created(){
          this.typeHeight.height=this.mountHeight(92);
          this.tableHeight.height=this.mountHeight(230);
          this.initSearchTree("knowTree");
          this.initSearch();
        },
        watch:{
          pageCode:function () {
            // if(this.pageCode=='6_2' && this.showPageCount==0){
            //   this.showPageCount++;
            // }
          }
        }
    }
</script>

<style scoped>
  .demo-split{
    border: 1px solid #dcdee2;
  }
  .demo-split-pane{
    padding: 10px;
  }
  .currentKnowId{
    background-color: #57a3f3 !important;
    color: #fbfbfc !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/knowledgeBase/KnowledgeBaseType.vue